export const RECEIVE_FETCHING = "RECEIVE_FETCHING";
export const RECEIVE_ERROR_MSG = "RECEIVE_ERROR_MSG";
export const ON_FETCH_ME = "ON_FETCH_ME";
export const ON_NOTIFICATION_OPEN = "ON_NOTIFICATION_OPEN";
export const ON_NOTIFICATION_CLOSE = "ON_NOTIFICATION_CLOSE";
export const ON_ANALYSIS_YEAR_CHANGE = "ON_ANALYSIS_YEAR_CHANGE";
